import { render, staticRenderFns } from "./PhoneSummaryTable.vue?vue&type=template&id=4a5fb2a7&scoped=true&"
import script from "./PhoneSummaryTable.vue?vue&type=script&lang=js&"
export * from "./PhoneSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSummaryTable.vue?vue&type=style&index=0&id=4a5fb2a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5fb2a7",
  null
  
)

export default component.exports